import { get, set, del } from 'idb-keyval';
import type { DocumentStrokes } from './strokes';

const PREFIX = 'draw:strokes:';

export async function loadStrokes(fileHash: string): Promise<DocumentStrokes | null> {
  const raw = await get<DocumentStrokes>(PREFIX + fileHash);
  return raw ?? null;
}

export async function saveStrokes(fileHash: string, strokes: DocumentStrokes): Promise<void> {
  await set(PREFIX + fileHash, strokes);
}

export async function clearStrokes(fileHash: string): Promise<void> {
  await del(PREFIX + fileHash);
}
